/**
 * Landing-page gate for the Anon exchange (exchange-clarity D1) — pure
 * derivation from ROOM state, never a localStorage flag. The landing shows
 * until the Anon's first participation: a stored name, or any anon-sent
 * message in loaded history. A scanned-but-bailed returner sees it again
 * (orientation still owed); a mid-exchange refresh or participated returner
 * skips it. Recovered histories count — an anon-sent message restored from
 * the DB is participation even when local storage was cleared.
 *
 * @param {string|null|undefined} anonName - The Anon's stored name (anonData.name)
 * @param {Array|null|undefined} chatMessages - Loaded room history
 * @returns {boolean} true once the Anon has participated in this room
 */
export const hasAnonParticipation = ({ anonName, chatMessages }) => {
  if (anonName) return true;
  return (chatMessages || []).some((m) => m?.sender === 'anon');
};
